import { Account, Participant } from '@app/api';
import { useTranslation } from 'react-i18next';

export const useParticipantDisplayName = (
  participant?: Account | Participant,
  defaultEmpty: boolean = false,
) => {
  const { t } = useTranslation();
  if (!participant) {
    return '';
  }
  if ('deletedAt' in participant && participant.deletedAt) {
    return t('participants.deleted');
  }
  if ('fullName' in participant && participant.fullName) {
    return participant.fullName;
  } else if (participant.firstName || participant.lastName) {
    if (participant.firstName && participant.lastName) {
      return `${participant.firstName} ${participant.lastName}`;
    }
    return participant.firstName || participant.lastName;
  } else if (!defaultEmpty) {
    return participant.email;
  } else {
    return '';
  }
};
